import React, { useEffect, useState } from 'react'
import './navbar.css'
// import Logo from '../../assets/logo.png'
import Logo from '../../assets/Bottle/Fusiq logo Black@3x.png'
import { Link } from "react-router-dom";

const NavLinks = () => {
    return (
        <ul>
            <li><Link to='/' className='link'>Home</Link></li>
            <li><Link to='#' className='link'>Shop</Link></li>
            <li><Link to='#' className='link'>About</Link></li>
            <li><Link to='/#' className='link'>Contact</Link></li>
        </ul>
    )
}

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className='section_padding' 
    // style={{ background: isScrolled ? "" : "transparent" }}
    style={{ background: isScrolled ? "#ff7f00" : "transparent" }}
    >
        <img src={Logo} alt="Logo" />
        <NavLinks/>
        <p><Link to='#' className='link'>Choose Your Flavour</Link></p>
    </nav>
  )
}

export default Navbar